export default __webpack_public_path__ + "static/flag_w.2f28edbb119ff4b797b17948bf89da3c.png";